import { ToastsTranslations } from '@/assets/locales/util/toasts/toasts.translations.pl.ts';

export const toastsTranslations: ToastsTranslations = {
  cannotCreateCycle: 'Cannot create a path for this employee.',
  continueFailed: 'Failed to continue upload',
  errorResolved: 'Error resolved',
  errorResolveFailed: 'Failed to resolve error',
  errorsResolved: 'Errors resolved',
  errorsResolveFailed: 'Failed to resolve errors',
  fetch: {
    error: 'An error occurred. Try again or let us know about the issue',
    success: 'Operation successful',
  },
  fileReplaceFailed: 'Failed to replace file',
  fileReplaceSuccess: 'File replaced successfully. Validation will start again.',
  fileTypeRequired:
    'File type is required. Please select the appropriate file type before uploading.',
  resolveAllErrors: 'Please resolve all errors before continuing',
  upload: {
    fileError: 'An error occurred while uploading the file. Check the file format and try again.',
    generalError: 'An error occurred while uploading data. Please try again later.',
  },
  uploadContinued: 'Upload continued successfully',
};
